module.exports = __webpack_public_path__ + "static/img/1.16a643d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/1.jpg
// module id = tAa0
// module chunks = 1